import {CSSProperties, useRef} from 'react'
import {DroppedEntries, droppedEntries} from '../core/storage/droppedFiles'
interface dropzoneProps {
  children: JSX.Element
  /** What was dropped, taken while the drop event lasts; expand with `collectDroppedFiles`. */
  onDrop: (drop: DroppedEntries) => void
  style?: CSSProperties
  highlight?: boolean
  /**
   * Renders a plain container instead: no drop handling, and no `drop_zone` id.
   *
   * Used by the read-only file browser in the wizard pick dialog, which must not accept uploads and
   * must not duplicate the id the Files panel's zone already owns.
   */
  disabled?: boolean
}

export const DropZone = ({
  children,
  onDrop,
  style,
  highlight = true,
  disabled = false,
}: dropzoneProps) => {
  const dragZone = useRef<HTMLDivElement>(null)
  var counter = 0

  if (disabled) {
    return <div style={style}>{children}</div>
  }

  return (
    <div
      style={style}
      onDragEnter={(e) => {
        e.preventDefault()
        counter++
        if (highlight && dragZone.current) {
          dragZone.current.classList.add('dragging')
        }
      }}
      onDragOver={(e) => {
        e.stopPropagation()
        e.preventDefault()
      }}
      onDragLeave={(e) => {
        if (e.currentTarget.id === 'drop_zone') {
          e.preventDefault()
          if (highlight && dragZone.current) {
            counter--
            if (counter === 0) dragZone.current.classList.remove('dragging')
          }
        }
      }}
      onDrop={(e) => {
        e.preventDefault()
        if (dragZone.current) {
          if (highlight) {
            dragZone.current.classList.remove('dragging')
          }
          onDrop(droppedEntries(e.dataTransfer))
          counter = 0
        }
      }}
      id='drop_zone'
      ref={dragZone}
    >
      {children}
    </div>
  )
}
